import { useEffect } from 'react';

const useFetching = (someFetch: () => void, dependencies: any[]) => {
  useEffect(() => {
    someFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useFetching;
